<template>
  <div class='EnbNave0102'
  :style="{
    backgroundColor: Prefes.nave.corBackground,
    fontFamily: Prefes.nave.font,
    color: Prefes.nave.corFont,
    fontStyle: parseInt(Prefes.nave.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.nave.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.nave.textDecoration) ? 'underline' : '',
    fontSize: Prefes.nave.fontHeight + 'px'
  }"
  >
    <div class="cont-top" :style="{ width: pref ? '95%' : '75%' }">
      <enb-logo01 class="logo"/>
      <div class="cont-search" :style="{ borderColor: Prefes.nave.corFont, '--nave-font': Prefes.nave.corFont }">
        <input
        v-model="search"
        type="text"
        placeholder="O que você está procurando? Digite aqui..."
        @keyup.enter="runSearch"
        >
        <div class="btn-search"
        :style="{ backgroundColor: Prefes.btn.corBackground }"
        @click="runSearch"
        >
          <search-icon01 :color="Prefes.btn.corFont"/>
        </div>
      </div>
      <div class="icons">
        <div class="cont-link-profile" @click="toProfile">
          <user-icon01 :color="Prefes.nave.corFont"/>
          <div class="labels">
            <label class="myAccount">
              {{ !Object.keys(Profile).length ? 'Login' : 'Minha Conta' }}
            </label>
            <label v-if="Object.keys(Profile).length" class="hello" :style="{ color: Prefes.btn.corBackground }">
              Olá, {{ Profile.nome }}!
            </label>
          </div>
        </div>
        <div class="cont-link-like" @click="$router.push('/likes')">
          <heartfull-icon :color="Prefes.nave.corFont"/>
          <label class="myAccount">Favoritos</label>
        </div>
      </div>
      <div class="cart"
      :style="{ backgroundColor: Prefes.cart.corBackground, color: Prefes.cart.corFont }"
      @click="ToggleCheckout01(true)"
      >
        <cart-icon01 :color="Prefes.cart.corFont" :tam="'40px'" :count="false"/>
        <div class="cart-labels">
          <span class="cart-title">CARRINHO</span>
          <span class="cart-qtda">{{ itens }} {{ itens === 1 ? 'produto' : 'produtos' }}</span>
        </div>
      </div>
    </div>
    <div class="cont-bottom"
    :style="{ backgroundColor: Prefes.btn.corBackground, color: Prefes.btn.corFont }"
    >
      <div class="cont-links" :style="{ width: pref ? '95%' : '75%' }">
        <div class="departamentos"
        @mouseenter="showsubnave = true"
        @mouseleave="showsubnave = false"
        >
          <div class="hamburger">
            <span :style="{ backgroundColor: Prefes.btn.corFont }"/>
            <span :style="{ backgroundColor: Prefes.btn.corFont }"/>
            <span :style="{ backgroundColor: Prefes.btn.corFont }"/>
          </div>
          CATEGORIAS
          <div class="sub-nave" v-if="showsubnave"
          :style="{ backgroundColor: Prefes.btn.corBackground, color: Prefes.btn.corFont }"
          >
            <sub-link-nave
            v-for="(c, k) in Categs"
            :key="k"
            :data="c"
            />
          </div>
        </div>
        <div class="link"
        v-for="(l, key) in LinksTheme01"
        :key="key"
        :style="{ borderColor: Prefes.btn.corFont }"
        @click="$router.push(l.path)"
        >
          {{ l.text.toUpperCase() }}
        </div>
      </div>
    </div>
    <cart-btn v-if="!pref" @click="ToggleCheckout01(true)"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbLogo01 from './EnbLogo01.vue'
import SubLinkNave from './SubLinkNave'
import SearchIcon01 from '../Icons/SearchIcon01'
import UserIcon01 from '../Icons/UserIcon01'
import HeartfullIcon from '../Icons/HeartfullIcon'
import CartIcon01 from '../Icons/CartIcon01'
import CartBtn from '../Checkout/CartBtn'
export default {
  name: 'EnbNave0102',
  components: { EnbLogo01, SubLinkNave, SearchIcon01, UserIcon01, HeartfullIcon, CartIcon01, CartBtn },
  props: {
    pref: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: '',
      showsubnave: false
    }
  },
  computed: {
    ...mapGetters(['LinksTheme01', 'Profile', 'Prefes', 'Categorias', 'CheckoutItens01', 'SearchTerm01']),
    Categs () {
      return this.Categorias.filter(c => c.name !== '')
    },
    itens () {
      return this.CheckoutItens01.length
    }
  },
  watch: {
    SearchTerm01 (val) {
      this.search = val
    }
  },
  methods: {
    ...mapActions(['ToggleCheckout01', 'ToggleSearch01', 'SetModal01', 'GetCategory', 'SetSearchTerm01']),
    toProfile() {
      if(Object.keys(this.Profile).length) {
        this.$router.push('/profile')
      } else {
        this.SetModal01({ component: 'EnbLogin01', active: true })
      }
    },
    runSearch () {
      if(!this.search.trim()) return
      this.SetSearchTerm01(this.search)
      this.ToggleSearch01(true)
    }
  },
  created () {
    this.GetCategory()
  }
}
</script>

<style scoped>
.EnbNave0102 {
  width: 100%;
  background-color: #333333;
}

.cont-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 75%;
  height: 90px;
  margin: auto;
}

.logo {
  width: 220px;
  height: 90px;
}

.logo :deep(img) {
  width: 220px;
  height: 80px;
  object-fit: contain;
}

.logo,
.icons,
.cart {
  flex-shrink: 0;
}

.cont-search {
  flex: 1;
  min-width: 160px;
  display: flex;
  height: 48px;
  margin: 0 3%;
  border: 1px solid;
  border-radius: 4px;
  overflow: hidden;
}

.cont-search input {
  flex: 1;
  min-width: 0;
  padding: 0 12px;
  border: 0;
  font-size: 15px;
  font-family: inherit;
  /* texto e placeholder na cor da fonte da navegação (preferência do usuário) */
  color: var(--nave-font, #FFFFFF);
  background-color: rgba(255, 255, 255, 0.12);
}

.cont-search input::placeholder {
  color: var(--nave-font, #FFFFFF);
  opacity: 0.6;
}

.cont-search input:focus {
  outline: none;
}

.btn-search {
  width: 46px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.icons {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-right: 3%;
}

.cont-link-profile,
.cont-link-like {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.cont-link-profile :deep(svg) {
  width: 32px;
  height: 32px;
}

.labels {
  display: flex;
  flex-direction: column;
}

.myAccount {
  display: block;
  font-size: 15px;
  line-height: 120%;
  cursor: pointer;
}

.hello {
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
}

.cart {
  display: flex;
  align-items: center;
  gap: 15px;
  height: 58px;
  padding: 0 25px 0 15px;
  border-radius: 4px;
  cursor: pointer;
}

.cart-labels {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.cart-title {
  font-size: 18px;
  font-weight: bold;
}

.cart-qtda {
  font-size: 12px;
}

.cont-bottom {
  width: 100%;
  height: 40px;
}

.cont-links {
  display: flex;
  width: 75%;
  height: 100%;
  margin: auto;
}

.departamentos {
  display: flex;
  align-items: center;
  gap: 25px;
  padding: 0 50px 0 50px;
  height: 100%;
  font-weight: bold;
  white-space: nowrap;
  background-color: rgba(0, 0, 0, 0.3);
  position: relative;
  cursor: pointer;
}

.hamburger {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.hamburger span {
  display: block;
  width: 26px;
  height: 3px;
  border-radius: 2px;
}

.sub-nave {
  width: 100%;
  position: absolute;
  top: 100%;
  left: 0;
  font-weight: normal;
  background-color: #FFFFFF;
  box-shadow: 1px 1px 1px 1px #CCCCCC;
  z-index: 999;
  overflow: hidden;
}

/* o SubLinkNave tem cor própria (preto/cinza); aqui segue as cores da barra */
.sub-nave :deep(.SubLinkNave) {
  color: inherit;
}

.sub-nave :deep(.SubLinkNave:hover) {
  background-color: rgba(0, 0, 0, 0.15);
}

.link {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
}

.link + .link::before {
  content: '';
  position: absolute;
  left: 0;
  height: 60%;
  border-left: thin solid;
  border-color: inherit;
  opacity: 0.6;
}

.link:hover {
  background-color: rgba(0, 0, 0, 0.15);
}

/* telas médias: usa quase toda a largura (o width vem inline, por isso o !important) */
@media (max-width: 1400px) {
  .cont-top,
  .cont-links {
    width: 95% !important;
  }

  .departamentos {
    padding: 0 25px;
  }
}

/* telas menores: some o texto ao lado dos ícones e do carrinho para sobrar espaço para a pesquisa */
@media (max-width: 1100px) {
  .logo,
  .logo :deep(img) {
    width: 150px;
  }

  .icons {
    gap: 16px;
  }

  .labels,
  .cont-link-like .myAccount,
  .cart-labels {
    display: none;
  }

  .cart {
    padding: 0 15px;
  }

  .departamentos {
    gap: 12px;
    padding: 0 15px;
  }

  .link {
    font-size: 14px;
  }
}

@media (max-width: 500px) {
  .EnbNave0102 {
    display: none;
  }
}
</style>
